const sanityClient = require('@sanity/client')
const client = sanityClient({
  projectId: '0ezh9eur',
  dataset: 'production',
  useCdn: true // `false` if you want to ensure fresh data
})

export default client 